module.exports = __webpack_public_path__ + "img/parent_photo@2x.51e91112.png";